/**
 * @generated SignedSource<<86173269e7b40da56ff13cbb6d0f20d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileEdit$data = {
  readonly avatarUrl: string | null;
  readonly profile: {
    readonly birthday: any | null;
    readonly commonName: string | null;
    readonly gender: string | null;
  };
  readonly " $fragmentType": "ProfileEdit";
};
export type ProfileEdit$key = {
  readonly " $data"?: ProfileEdit$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileEdit">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileEdit",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InfluencerInfo",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "commonName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gender",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "birthday",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "30b55e123551e8109a1a1559da7dc56a";

export default node;
